import ENV from "config/Env";

type ZohoDeskASAPCallback = () => void;

declare global {
  interface Window {
    ZohoDeskAsapReady?: (callback: ZohoDeskASAPCallback) => void;
    ZohoDeskAsap__asyncalls?: ZohoDeskASAPCallback[] | null;
    ZohoDeskAsapReadyStatus: boolean;
    ZohoDeskAsap: {
      invoke: (method: string, callback?: (setValue: (value: string) => void) => void) => void;
      set: (property: string, value: string) => void;
    };
  }
}

export const setZohoDeskASAP = () => {
  window.ZohoDeskAsapReady = function (callback: ZohoDeskASAPCallback) {
    window.ZohoDeskAsap__asyncalls = window.ZohoDeskAsap__asyncalls || [];
    if (window.ZohoDeskAsapReadyStatus) {
      window.ZohoDeskAsap__asyncalls.push(callback);
      window.ZohoDeskAsap__asyncalls.forEach(callback => callback());
      window.ZohoDeskAsap__asyncalls = null;
    } else window.ZohoDeskAsap__asyncalls.push(callback);
  };

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = ENV.zohoASAP;
  script.defer = true;

  document.getElementsByTagName("head")[0].appendChild(script);
};

export const loginZohoDeskASAP = (zohoAsapJWT: string) => {
  if (window.ZohoDeskAsapReady) {
    window.ZohoDeskAsapReady(() => {
      window.ZohoDeskAsap.invoke("login", (setValue: (value: string) => void) => {
        setValue(zohoAsapJWT);
        window.ZohoDeskAsap.set("app.lang", localStorage.getItem("locale")?.replace("-", "_") || "en_GB");
      });
    });
  }
};

export const toggleZohoDeskASAP = () => {
  const ZohohcAsapWebButton = document.getElementById("zohohc-asap-web-button");
  if (!ZohohcAsapWebButton) return;

  if (ZohohcAsapWebButton.style.left === "auto") {
    ZohohcAsapWebButton.click();
    ZohohcAsapWebButton.style.left = "-100px";
  } else {
    ZohohcAsapWebButton.click();
    ZohohcAsapWebButton.style.left = "auto";
    ZohohcAsapWebButton.addEventListener("click", () => (ZohohcAsapWebButton.style.left = "-100px"), { once: true });
  }
};

export const logoutZohoDeskASAP = () => {
  if (window.ZohoDeskAsapReady) {
    window.ZohoDeskAsapReady(() => window.ZohoDeskAsap.invoke("logout"));
    const ZohohcAsapWebButton = document.getElementById("zohohc-asap-web-button");
    if (ZohohcAsapWebButton?.style.left === "auto") {
      ZohohcAsapWebButton.click();
      ZohohcAsapWebButton.style.left = "-100px";
    }
  }
};
